import { get } from "lodash";
import { Navigate, useRoutes } from "react-router-dom";
import { useAppSelector } from "../hooks/useSelector";
import DashboardLayout from "../layouts/Dashboard";
import MinimalLayout from "../layouts/Minimal";
import AccountProfilePage from "../pages/AccountProfilePage";
import CategoryDetail from "../pages/category/CategoryDetail";
import ChangePasswordPage from "../pages/ChangePasswordPage";
import Checkout from "../pages/checkout/Checkout";
import PostCheckout from "../pages/checkout/PostCheckout";
import VoucherPage from "../pages/checkout/VoucherPage";
import Event from "../pages/event/Event";
import EventDetail from "../pages/event/EventDetail";
import EventCreate from "../pages/event/EventEditPage";
import ForgotPage from "../pages/ForgotPage";
import LoadingPage from "../pages/LoadingPage";
import OrderWrapper from "../pages/order/OrderWrapper";
import PageNotFound from "../pages/PageNotFound";
import Privacy from "../pages/privacy/Privacy";
import EventDetailPublic from "../pages/public/EventDetailPublic";
import Home from "../pages/public/Home";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import SignInPage from "../pages/SignInPage";
import TermCondition from "../pages/tnc/TermCondition";
import UserCreate from "../pages/UserCreate";
import UserEdit from "../pages/UserEdit";
import UserList from "../pages/UserList";
import Voucher from "../pages/voucher/Voucher";
import VoucherCreate from "../pages/voucher/VoucherCreate";
import UrlShortener from "../components/UrlShortener";
import BulkEmailMonitoring from "../pages/admin/BulkEmailMonitoring";

export default function Routes() {
  const { user } = useAppSelector((state) => state.global);
  const chooseDefaultRoute: any = () => {
    const role = get(user, "role_id");
    if (role === 1 || role === 3) {
      return { element: <Navigate to="/admin/event" />, index: true };
    }
    return { element: <LoadingPage />, index: true };
  };
  return useRoutes([
    {
      path: "/admin",
      element: <DashboardLayout />,
      children: [
        {
          path: "/admin",
          children: [chooseDefaultRoute()],
        },
        {
          path: "/admin",
          children: [{ element: <Navigate to="/admin/event" />, index: true }],
        },
        {
          path: "/admin/profile",
          children: [
            { element: <AccountProfilePage />, index: true },
            {
              element: <ChangePasswordPage />,
              path: "/admin/profile/change-password",
            },
          ],
        },
        {
          path: "/admin/event",
          children: [
            { element: <Event />, index: true },
            {
              element: <EventDetail />,
              path: "/admin/event/:id",
            },
            {
              element: <CategoryDetail />,
              path: "/admin/event/:eventid/category/:id",
            },
            {
              element: <EventCreate />,
              path: "/admin/event/edit/:id",
            },
            {
              element: <EventCreate />,
              path: "/admin/event/create-event",
            },
            {
              element: <BulkEmailMonitoring />,
              path: "/admin/event/:eventId/bulk-email-monitoring",
            },
          ],
        },
        {
          path: "/admin/voucher",
          children: [
            { element: <Voucher />, index: true },
            {
              element: <VoucherCreate />,
              path: "/admin/voucher/create-voucher",
            },
            {
              element: <VoucherCreate />,
              path: "/admin/voucher/edit/:id",
            },
          ],
        },
        {
          path: "/admin/users",
          children: [
            { element: <UserList />, index: true },
            {
              element: <UserCreate />,
              path: "/admin/users/create-user",
            },
            {
              element: <UserEdit />,
              path: "/admin/users/edit/:id",
            },
          ],
        },
        {
          path: "/admin/users",
          element: <Navigate to="/admin/users/manage" />,
        },
        {
          path: "/admin/order/:id",
          element: <OrderWrapper />,
        },
        {
          path: "*",
          element: <PageNotFound fullWidth={false} />,
        },
      ],
    },
    {
      path: "/admin/login",
      element: <SignInPage />,
      index: true,
    },
    {
      path: "/order-detail",
      element: <VoucherPage />,
    },
    {
      path: "/",
      element: <MinimalLayout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/ul/:shortcode",
          element: <UrlShortener />,
        },
        {
          path: "/event/:id",
          element: <EventDetailPublic />,
        },
        {
          path: "/order",
          element: <Checkout />,
        },
        {
          path: "/post-checkout",
          element: <PostCheckout fullWidth={true} />,
        },
        {
          path: "/signin",
          element: <SignInPage />,
        },
        {
          path: "/tnc",
          element: <TermCondition />,
        },
        {
          path: "/privacy",
          element: <Privacy />,
        },
        {
          path: "/forgot-password",
          element: <ResetPasswordPage />,
        },
        {
          path: "/reset-password",
          element: <ForgotPage />,
        },
        {
          path: "*",
          element: <PageNotFound fullWidth />,
        },
      ],
    },
  ]);
}
